import { Div, Select, Ref, DateInput, TextInput, NumberInput, Checkbox, Span, JsonViewer, RefSerializer, Collection, MultilineInput, DateTimeInput } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { Step } from "../Steps/Step/Step";
import { Box } from "./Utils/Box";
import { Center } from "./Utils/Center";
import { SmallHeader } from "./Utils/SmallHeader";
import { TimeUtils } from "../Utils/TimeUtils";
import { StepData } from "../Steps/Step/StepData";
import { PrimaryButton } from "./Utils/PrimaryButton";
import { DateSlider } from "./Utils/DateSlider";


export const nameof = <T>(name: keyof T) => name;

export class StepDataEditor extends Div
{
    constructor(private step: Step<any>, showSaveButton = true)
    {
        super();

        this.Append(
            ...Object.entries(step.Data).map(([key, value]) =>
            {
                const label = new SmallHeader(key).Padding(4).Margin(4).MarginBottom(0).BorderNone()
                let input: appendable | undefined = undefined;

                if (key === nameof<StepData>("State"))
                {
                    input = new Select(step.Data.State, step.AllStates);
                }
                else if (value instanceof Ref)
                {
                    if (value.value instanceof Date)
                    {
                        input = new DateSlider(value);
                    }
                    else
                    {
                        switch (typeof value.value)
                        {
                            case "string":
                                input = new MultilineInput(value).Rows(1);
                                break;
                            case "number":
                                input = new NumberInput(value);
                                break;
                            case "boolean":
                                input = new Checkbox(value);
                                break;
                            default:
                                input = new Span(value.value);
                                break;
                        }
                    }
                }
                else if (value instanceof Date)
                {
                    input = new Span(TimeUtils.FormattedDateTime(value));
                }
                else if (Array.isArray(value))
                {
                    input = new JsonViewer(RefSerializer.Flatenize(value));
                }
                else if (value instanceof Collection)
                {
                    input = new JsonViewer(RefSerializer.Flatenize(value.Items));
                }

                if (input)
                    input.Background("#fff").Margin(8)//.WidthPercent(95).MarginTop(0)

                return new Box(label, input).WidthPercent(100).TextAlignLeft();
            }),
            showSaveButton && new Center(
                new PrimaryButton("Zapisz").OnClick(() =>
                {
                    this.step.CallOnChange();
                })
            ).Margin(8)
        );
    }
}
